import Constant from '@/const';
import axios from 'axios';

const putOperationMarking = async (idOM, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/document/medical-treatment/${idOM}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putOperationMarking;
